export default {
  A1: {
    id: 'A1',
    bed: 0,
    den: false,
    flex: false,
    adaptable: true,
    bath: 1,
    size: '424 - 427',
    img: 'a1',
    levels: ['4', '5', '6-13'],
    soldout: true,
  },
  A2: {
    id: 'A2',
    bed: 0,
    den: false,
    flex: false,
    adaptable: false,
    bath: 1,
    size: '451 - 458',
    img: 'a2',
    levels: ['4', '5', '6-13'],
    soldout: true,
  },
  A3: {
    id: 'A3',
    bed: 0,
    den: false,
    flex: false,
    adaptable: false,
    bath: 1,
    size: '399',
    img: 'a3',
    levels: ['14', '15-18'],
    soldout: true,
  },
  A4: {
    id: 'A4',
    bed: 0,
    den: false,
    flex: false,
    adaptable: false,
    bath: 1,
    size: '470',
    img: 'a4',
    levels: ['4'],
    soldout: true,
  },
  A5: {
    id: 'A5',
    bed: 0,
    den: false,
    flex: false,
    adaptable: false,
    bath: 1,
    size: '485',
    img: 'a5',
    levels: ['4'],
    soldout: true,
  },
  B1: {
    id: 'B1',
    bed: 1,
    den: false,
    flex: false,
    adaptable: false,
    bath: 1,
    size: '468 - 476',
    img: 'b1',
    levels: ['3', '4', '5', '6-13'],
    soldout: true,
  },
  B2: {
    id: 'B2',
    bed: 1,
    den: false,
    flex: false,
    adaptable: false,
    bath: 1,
    size: '515 - 521',
    img: 'b2',
    levels: ['3', '4', '5', '6-13'],
    soldout: true,
  },
  B3: {
    id: 'B3',
    bed: 1,
    den: false,
    flex: true,
    adaptable: false,
    bath: 1,
    size: '595',
    img: 'b3',
    levels: ['6-13'],
    soldout: true,
  },
  B4: {
    id: 'B4',
    bed: 1,
    den: false,
    flex: false,
    adaptable: false,
    bath: 1,
    size: '507',
    img: 'b4',
    levels: ['6-13'],
    soldout: true,
  },
  B5: {
    id: 'B5',
    bed: 1,
    den: false,
    flex: false,
    adaptable: false,
    bath: 1,
    size: '536 - 540',
    img: 'b5',
    levels: ['4', '5', '6-13'],
    soldout: true,
  },
  B6: {
    id: 'B6',
    bed: 1,
    den: false,
    flex: true,
    adaptable: true,
    bath: 1,
    size: '580 - 581',
    img: 'b6',
    levels: ['5', '6-13'],
    soldout: true,
  },
  B7: {
    id: 'B7',
    bed: 1,
    den: false,
    flex: true,
    adaptable: true,
    bath: 1,
    size: '631 - 633',
    img: 'b7',
    levels: ['5', '6-13'],
    soldout: true,
  },
  B8: {
    id: 'B8',
    bed: 2,
    junior: true,
    den: false,
    flex: false,
    adaptable: true,
    bath: 1,
    size: '663 - 664',
    img: 'b8',
    levels: ['14', '15-18', '19', '20-32'],
    soldout: true,
  },
  B9: {
    id: 'B9',
    bed: 1,
    den: false,
    flex: true,
    adaptable: false,
    bath: 1,
    size: '628',
    img: 'b9',
    levels: ['19', '20-32'],
    soldout: true,
  },
  B10: {
    id: 'B10',
    bed: 1,
    den: true,
    flex: false,
    adaptable: false,
    bath: 1,
    size: '749',
    img: 'b10',
    levels: ['2'],
    soldout: true,
  },
  B11: {
    id: 'B11',
    bed: 1,
    den: true,
    flex: false,
    adaptable: true,
    bath: 1,
    size: '751',
    img: 'b11',
    levels: ['3'],
    soldout: true,
  },
  B12: {
    id: 'B12',
    bed: 1,
    den: false,
    flex: false,
    adaptable: false,
    bath: 1,
    size: '480 - 496',
    img: 'b12',
    levels: ['3', '4'],
    soldout: true,
  },
  B13: {
    id: 'B13',
    bed: 1,
    den: false,
    flex: false,
    adaptable: false,
    bath: 1,
    size: '552 - 572',
    img: 'b13',
    levels: ['3', '4'],
    soldout: true,
  },
  B14: {
    id: 'B14',
    bed: 1,
    den: false,
    flex: false,
    adaptable: false,
    bath: 1,
    size: '604 - 625',
    img: 'b14',
    levels: ['3', '4'],
    soldout: true,
  },
  B14a: {
    id: 'B14a',
    bed: 1,
    den: false,
    flex: true,
    adaptable: false,
    bath: 1,
    size: '686',
    img: 'b14a',
    levels: ['4'],
    soldout: true,
  },
  B15: {
    id: 'B15',
    bed: 1,
    den: false,
    flex: true,
    adaptable: false,
    bath: 1,
    size: '611 - 617',
    img: 'b15',
    levels: ['4'],
    soldout: true,
  },
  B15a: {
    id: 'B15a',
    bed: 1,
    den: false,
    flex: true,
    adaptable: false,
    bath: 1,
    size: '637',
    img: 'b15a',
    levels: ['4'],
    soldout: true,
  },
  B16: {
    id: 'B16',
    bed: 1,
    den: false,
    flex: false,
    adaptable: true,
    bath: 1,
    size: '570',
    img: 'b16',
    levels: ['4'],
    soldout: true,
  },
  C1: {
    id: 'C1',
    bed: 2,
    den: false,
    flex: false,
    adaptable: true,
    bath: 2,
    size: '914 - 937',
    img: 'c1',
    levels: ['3', '4', '5', '6-13'],
    soldout: true,
  },
  C1a: {
    id: 'C1a',
    bed: 2,
    den: false,
    flex: false,
    adaptable: false,
    bath: 2,
    size: '922',
    img: 'c1a',
    levels: ['14', '15-18'],
    soldout: true,
  },
  C1b: {
    id: 'C1b',
    bed: 2,
    den: false,
    flex: false,
    adaptable: false,
    bath: 2,
    size: '951',
    img: 'c1b',
    levels: ['19', '20-32'],
  },
  C2: {
    id: 'C2',
    bed: 2,
    den: false,
    flex: false,
    adaptable: false,
    bath: 2,
    size: '867 - 868',
    img: 'c2',
    levels: ['5', '6-13'],
    soldout: true,
  },
  C3: {
    id: 'C3',
    bed: 2,
    den: true,
    flex: false,
    adaptable: false,
    bath: 2,
    size: '930 - 931',
    img: 'c3',
    levels: ['14', '15-18', '19', '20-32'],
  },
  C4: {
    id: 'C4',
    bed: 2,
    den: false,
    flex: false,
    adaptable: true,
    bath: 2,
    size: '862',
    img: 'c4',
    levels: ['14', '15-18'],
    soldout: true,
  },
  C5: {
    id: 'C5',
    bed: 2,
    den: false,
    flex: true,
    adaptable: false,
    bath: 2,
    size: '915',
    img: 'c5',
    levels: ['14', '15-18'],
  },
  C6: {
    id: 'C6',
    bed: 2,
    den: false,
    flex: false,
    adaptable: false,
    bath: 2,
    size: '838',
    img: 'c6',
    levels: ['14', '15-18'],
    soldout: true,
  },
  C7: {
    id: 'C7',
    bed: 2,
    den: false,
    flex: false,
    adaptable: false,
    bath: 2,
    size: '899',
    img: 'c7',
    levels: ['19', '20-32'],
  },
  C8: {
    id: 'C8',
    bed: 2,
    den: false,
    flex: false,
    adaptable: false,
    bath: 2,
    size: '850',
    img: 'c8',
    levels: ['4'],
    soldout: true,
  },
  D1: {
    id: 'D1',
    bed: 3,
    den: false,
    flex: false,
    adaptable: false,
    bath: 2,
    size: '1164',
    img: 'd1',
    levels: ['19', '20-32'],
  },
  D2: {
    id: 'D2',
    bed: 2,
    den: false,
    flex: false,
    adaptable: false,
    bath: 2,
    size: '1040',
    img: 'd2',
    levels: ['4'],
    soldout: true,
  },
  TH1: {
    id: 'TH1',
    bed: 3,
    den: false,
    flex: true,
    adaptable: false,
    bath: 2.5,
    size: '1395',
    interior: '1229',
    exterior: '166',
    img: 'th1',
    levels: ['2', '3'],
    soldout: true,
  },
  TH2: {
    id: 'TH2',
    bed: 3,
    den: false,
    flex: false,
    adaptable: false,
    bath: 2.5,
    size: '1372',
    interior: '1207',
    exterior: '165',
    img: 'th2',
    levels: ['2', '3'],
    soldout: true,
  },
  TH3: {
    id: 'TH3',
    bed: 3,
    den: false,
    flex: false,
    adaptable: false,
    bath: 2.5,
    size: '1366',
    interior: '1206',
    exterior: '160',
    img: 'th3',
    levels: ['2', '3'],
    soldout: true,
  },
  TH4: {
    id: 'TH4',
    bed: 3,
    den: false,
    flex: true,
    adaptable: false,
    bath: 2.5,
    size: '1574',
    interior: '1265',
    exterior: '309',
    img: 'th4',
    levels: ['2', '3'],
    soldout: true,
  },
  TH5: {
    id: 'TH5',
    bed: 3,
    den: false,
    flex: false,
    adaptable: false,
    bath: 2.5,
    size: '1656',
    interior: '1351',
    exterior: '305',
    img: 'th5',
    levels: ['2', '3'],
    soldout: true,
  },
  TH6: {
    id: 'TH6',
    bed: 3,
    den: false,
    flex: false,
    adaptable: false,
    bath: 2.5,
    size: '1591',
    interior: '1374',
    exterior: '217',
    img: 'th6',
    levels: ['2', '3'],
    soldout: true,
  },
  TH7: {
    id: 'TH7',
    bed: 3,
    den: false,
    flex: false,
    adaptable: false,
    bath: 2.5,
    size: '1570',
    interior: '1362',
    exterior: '208',
    img: 'th7',
    levels: ['2', '3'],
    soldout: true,
  },
  TH8: {
    id: 'TH8',
    bed: 3,
    den: false,
    flex: false,
    adaptable: false,
    bath: 2.5,
    size: '1487',
    interior: '1266',
    exterior: '221',
    img: 'th8',
    levels: ['2', '3'],
    soldout: true,
  },
  TH9: {
    id: 'TH9',
    bed: 3,
    den: false,
    flex: false,
    adaptable: false,
    bath: 2.5,
    size: '1530',
    interior: '1316',
    exterior: '214',
    img: 'th9',
    levels: ['2', '3'],
    soldout: true,
  },
  TH10: {
    id: 'TH10',
    bed: 3,
    den: false,
    flex: false,
    adaptable: false,
    bath: 2.5,
    size: '1549',
    interior: '1343',
    exterior: '206',
    img: 'th10',
    levels: ['2', '3'],
    soldout: true,
  },
  TH11: {
    id: 'TH11',
    bed: 3,
    den: false,
    flex: false,
    adaptable: false,
    bath: 2.5,
    size: '1536',
    interior: '1324',
    exterior: '212',
    img: 'th11',
    levels: ['2', '3'],
    soldout: true,
  },
  TH12: {
    id: 'TH12',
    bed: 3,
    den: false,
    flex: true,
    adaptable: false,
    bath: 2.5,
    size: '1558',
    interior: '1263',
    exterior: '295',
    img: 'th12',
    levels: ['2', '3'],
    soldout: true,
  },
  TH13: {
    id: 'TH13',
    bed: 3,
    den: false,
    flex: false,
    adaptable: false,
    family: true,
    bath: 2.5,
    size: '1787',
    interior: '1459',
    exterior: '328',
    img: 'th13',
    levels: ['2', '3'],
    soldout: true,
  },
};



// WEBPACK FOOTER //
// ./src/data/floorplans.js